import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {GalleryService} from "../../../../shared/services/gallery.service";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {environment} from "../../../../../environments/environment";

@Component({
    selector: 'app-image-gallery',
    templateUrl: './image-gallery.component.html',
    styleUrls: ['./image-gallery.component.scss']
})
export class ImageGalleryComponent implements OnInit {
    selectedVideo: { link: any, title: string, description: string } | null = null;
    sanitizedVideoUrl: any;
    selectedSection: string = 'Image Gallery';
    pageTitle: string;
    activeIndex: number | null = null;
    galleries: any;
    currentPage: number = 1;
    perPage: number = 9;
    totalPages: number = 1;
    pages: number[] = [];
    images = [];
    imageLoaded = false;
    isModalOpen = false;
    currentImageIndex = 0;
    showModal: boolean = false;
    modalVideo: any = null;
    videosYoutube = [
        {
            title: 'HIGHLIGHTS OF SPANDAN SPORTS MEET 2024 ARNI UNIVERSITY',
            link: 'https://www.youtube.com/embed/o2XShZHciAo?si=ZAeYd2dk5aNO5ZNv',
            thumbnail: 'assets/img/video-gallery-thumbnails/highlights-of-spandan-sports-meet-2024-arni-university.webp',
            description: 'Relive the unforgettable moments from the Spandan Sports Meet 2024, hosted by Arni University. With over 300 participants competing in a wide range of athletic events, this video showcases the highlights of various sports, from fast-paced sprints to intense javelin throws, high jump, volleyball, and badminton. Watch as students from different schools and colleges come together for a day full of energy, competition, and sportsmanship.'
        },
        {
            title: 'ARNI UNIVERSITY ORGANIZED INTERNATIONAL CONFERENCE 2024 ASSOCIATION WITH INTI UNIVERSITY MALAYSIA',
            link: 'https://www.youtube.com/embed/plHHHDnscCA?si=bMrwDOWthc1aLyb8',
            thumbnail: 'assets/img/video-gallery-thumbnails/arni-university-organized-international-conference-2024-association-with-inti-university-malaysia.webp',
            description: 'Arni University, in association with INTI University Malaysia, successfully hosted an insightful International Conference in December 2024. Themed “Redefining Possibilities: Cross Multi-Disciplinary Approaches to Global Challenges,” the conference featured global scholars and experts who shared their research and innovative solutions for addressing contemporary global issues. Watch this video to explore the exciting discussions and key moments from this groundbreaking event.'
        },
        {
            title: 'ARNI UNIVERSITY CELEBRATED CHILDREN\'S DAY',
            link: 'https://www.youtube.com/embed/8AuxJP_Z4C0?si=HwFykaE6joPwDR4g',
            thumbnail: 'assets/img/video-gallery-thumbnails/arni-university-celebrated-childrens-day.webp',
            description: 'Arni University celebrated Children\'s Day with joy and enthusiasm. The event aimed to bring smiles to students’ faces and provide a platform for them to showcase their creativity and talents. From fun activities to interactive performances, the day was filled with excitement and engagement. Watch how we celebrated this special occasion with our vibrant campus community.'
        },
        {
            title: 'ARNI UNIVERSITY MANAGEMENT STUDENTS VISITED GNA GEARS LTD. HOSHIARPUR PUNJAB',
            link: 'https://www.youtube.com/embed/5g9wgrCB1rg?si=XTiRFv17aEacnE1l',
            thumbnail: 'assets/img/video-gallery-thumbnails/arni-university-management-students-visited-gna-gears-ltd-hoshiarpur-punjab.webp',
            description: 'Our management students had the opportunity to visit GNA Gears Ltd., a leading manufacturer of automotive gears and shafts. The industrial visit to this cutting-edge facility in Hoshiarpur provided valuable insights into the production process, machinery, and engineering techniques used in the automotive industry. Watch this video to see how students interacted with industry professionals and gained hands-on experience in a real-world setting.'
        },
        {
            title: 'Highlights of the cricket match held on 06 October 2024 in the university campus.',
            link: 'https://www.youtube.com/embed/24dlojj16T0?si=n_KA_72PPSUSPIWc',
            thumbnail: 'assets/img/video-gallery-thumbnails/highlights-of-the-cricket-match-held-on-06-october-2024-in-the-university-campus.webp',
            description: 'Catch all the exciting moments from the cricket match held at Arni University on October 6, 2024. The match was filled with thrilling overs, spectacular fielding, and brilliant batting performances. Watch as the teams battle it out on the field in this action-packed highlight reel.'
        },
        {
            title: 'ARNI UNIVERSITY – BEST UNIVERSITY IN HIMACHAL PRADESH',
            link: 'https://www.youtube.com/embed/Hw78_2JXVSg?si=rWmGAwebbZLUqFXZ',
            thumbnail: 'assets/img/video-gallery-thumbnails/arni-university-best-university-in-himachal-pradesh.webp',
            description: 'Arni University stands out as the premier educational institution in Himachal Pradesh, offering a blend of academic excellence and innovative research programs. Recognized for its green campus, world-class infrastructure, and collaborations with top global institutions, Arni University has earned accolades such as the “Most Innovative University” and “Best University with the Highest Social Impact.” Watch this video to learn about the university’s achievements, accolades, and the transformative impact it has on students and the community.'
        },
        {
            title: 'STUDENTS ARE EXITED FOR THE MOST AWAITED MULTICULTURAL EVENT OF THE YEAR, PARIVARTAN -3.0',
            link: 'https://www.youtube.com/embed/rIdmmEu_tQE?si=5GVTtKNg8rQrcYXg',
            thumbnail: 'assets/img/video-gallery-thumbnails/students-are-excited-for-the-most-awaited-multicultural-event-of-the-year-parivartan-3.0.webp',
            description: 'PARIVARTAN 3.0 is the most anticipated multicultural event of the year at Arni University. This event is a celebration of diversity, with live performances, dance, music, and a lot of entertainment. The students are excited to showcase their talents in a festival that will bring people together from various backgrounds. Get a sneak peek into what promises to be an unforgettable celebration.'
        },
        {
            title: 'ARNI UNIVERSITY PRESENTS THE MOST AWAITED MULTICULTURAL EVENT OF THE YEAR, PARIVARTAN -3.0',
            link: 'https://www.youtube.com/embed/CxYLhz_3BnU?si=p3RDFKOZJH97KjfN',
            thumbnail: 'assets/img/video-gallery-thumbnails/arni-university-presents-the-most-awaited-multicultural-event-of-the-year-parivartan-3-0.webp',
            description: 'Join us for the most awaited event at Arni University, PARIVARTAN 3.0. With live concerts, vibrant dance performances, and exciting music, this multicultural event will showcase the diverse talents of our students. The festival promises a night full of fun, entertainment, and cross-cultural exchange. Watch this video to get a glimpse of what’s in store.'
        },
        {
            title: 'Arni School of Pharmacy - Admission Open 2023-2024',
            link: 'https://www.youtube.com/embed/icZJDlwM1D4?si=pgtxsu6ZZCN7upKO',
            thumbnail: 'assets/img/video-gallery-thumbnails/arni-school-of-pharmacy-admission-open-2023-2024.webp',
            description: 'Arni School of Pharmacy is now accepting admissions for the academic year 2023-2024. Whether you’re looking to pursue a career in pharmacy or expand your knowledge, this video provides insight into the programs, campus facilities, and opportunities at Arni School of Pharmacy. Don’t miss out on a chance to join one of the most reputable pharmacy schools in the region.'
        },
        {
            title: 'HIMACHAL PRADESH WEIGHTLIFTING CHAMPIONSHIP 2022 HELD AT ARNI UNIVERSITY | DAY-1',
            link: 'https://www.youtube.com/embed/OWrX5j28whA?si=rPj9nwm8uMN8HBSs',
            thumbnail: 'assets/img/video-gallery-thumbnails/glimpses-of-himachal-pradesh-weightlifting-championship-2022-held-at-arni-university.webp',
            description: 'The Himachal Pradesh Weightlifting Championship 2022, held at Arni University, was an intense and exciting competition. Watch the best moments from Day 1, where top athletes from across the state competed in various weight categories. Get a closer look at the fierce competition and the skillful performances in this power-packed event.'
        },
        {
            title: 'GLIMPSES OF HIMACHAL PRADESH WEIGHTLIFTING CHAMPIONSHIP 2022 HELD AT ARNI UNIVERSITY',
            link: 'https://www.youtube.com/embed/0ff4SNLgRCE?si=NGOJKNQ7rjueVTbi',
            thumbnail: 'assets/img/video-gallery-thumbnails/himachal-pradesh-weightlifting-championship-2022-held-at-arni-university-day-1.webp',
            description: 'Take a look at the highlights from the Himachal Pradesh Weightlifting Championship 2022, held at Arni University. This video showcases the strength and determination of the athletes as they competed in various categories. Watch the inspiring moments from the competition and witness the grit and perseverance on display.'
        },
     /*   {
            title: 'BEST PUNJABI SONG 2022/ FEAT. ARNI UNI/ NEW YEAR 2023 /WRITTEN AND PERFORMED BY STUDENT',
            link: 'https://youtu.be/AtSDvVHD72U?si=hjo1JwhkgEXbMYCl',
            thumbnail: 'assets/img/video-gallery-thumbnails/best-punjabi-song-2022-feat-arni-uni-new-year-2023-written-and-performed-by-student.webp',
            description: 'One of the standout Punjabi songs of 2022, performed during the New Year 2023 celebration, was a remarkable piece written and performed by a talented student from Arni University. This song gained attention not only for its catchy beats and energetic rhythm but also for its heartfelt lyrics that resonated with the spirit of new beginnings and celebration. As part of the university’s cultural festivities, the performance highlighted the artistic talent nurtured within the institution.'
        }*/
    ];


    constructor(private route: ActivatedRoute,
                private router: Router,
                private galleryService: GalleryService,
                private sanitizer: DomSanitizer) {
        this.route.data.subscribe(data => {
            this.pageTitle = data.title;
        });
    }

    ngOnInit(): void {
        this.getGallery();
    }

    playVideo(link: string, title: string, description: string) {
        this.selectedVideo = {link: link, title: title, description: description};
        this.sanitizedVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(link);
    }

    closeVideo() {
        this.selectedVideo = null;
        this.sanitizedVideoUrl = null;
    }

    getGallery() {
        const params = {
            page: this.currentPage,
            per_page: this.perPage
        };
        this.galleryService.get(params).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.galleries = data['data'];
                this.totalPages = Math.ceil(data.total / this.perPage);
                this.generatePagination();
                window.scrollTo(10, 0);
            }
        });
    }

    generatePagination() {
        this.pages = [];
        for (let i = 1; i <= this.totalPages; i++) {
            if (i <= 10 || i === this.totalPages) {
                this.pages.push(i);
            } else if (i === 6) {
                this.pages.push(0); // Represents "..."
            }
        }
    }

    goTo(url: string) {
        this.router.navigateByUrl(url);
    }

    goToPage(page: number) {
        if (page === 0) return;
        this.currentPage = page;
        this.getGallery();
    }

    prevPage() {
        if (this.currentPage > 1) {
            this.currentPage--;
            this.getGallery();
        }
    }

    nextPage() {
        if (this.currentPage < this.totalPages) {
            this.currentPage++;
            this.getGallery();
        }
    }

    // Open modal with specific image
    openModal(gallery: any): void {
        this.images = gallery;
        this.currentImageIndex = 0;
        this.isModalOpen = true;
        // Disable body scroll when modal is open
        document.body.style.overflow = 'hidden';
    }

    onImageLoad() {
        this.imageLoaded = true;
    }

    // Close modal
    closeModal(): void {
        this.isModalOpen = false;
        // Re-enable body scroll
        document.body.style.overflow = 'auto';
    }

    // Navigate to next image
    nextImage(): void {
        this.currentImageIndex = (this.currentImageIndex + 1) % this.images.length;
    }

    // Navigate to previous image
    prevImage(): void {
        this.currentImageIndex = (this.currentImageIndex - 1 + this.images.length) % this.images.length;
    }

    // Select specific image by index
    selectImage(index: number): void {
        this.currentImageIndex = index;
    }

    // Handle keyboard events
    onKeyDown(event: KeyboardEvent): void {
        if (!this.isModalOpen) return;

        switch (event.key) {
            case 'Escape':
                this.closeModal();
                break;
            case 'ArrowRight':
                this.nextImage();
                break;
            case 'ArrowLeft':
                this.prevImage();
                break;
        }
    }


    protected readonly environment = environment;
}
